import {
    FaHome, FaUsers, FaList, FaMoneyBillWave, FaFileUpload,
    FaCalendarAlt, FaTv, FaInfoCircle, FaServer, FaSlidersH, FaLock,
    FaChartLine, FaChartBar, FaFileExcel
} from "react-icons/fa";

// Definición completa de todos los menús del sidebar
export const AVAILABLE_MENUS = [
    { id: 'inicio', label: 'Inicio', icon: FaHome, parent: null, color: 'bg-cyan-500' },
    { id: 'admon', label: 'Admon', icon: FaUsers, parent: null, color: 'bg-blue-500' },
    { id: 'admon_listado', label: 'Listado', icon: FaList, parent: 'admon', color: 'bg-blue-400' },
    { id: 'admon_financiero', label: 'Financiero', icon: FaMoneyBillWave, parent: 'admon', color: 'bg-green-500' },
    { id: 'admon_procesador_csv', label: 'Procesador CSV', icon: FaFileUpload, parent: 'admon', color: 'bg-purple-500' },
    { id: 'cdrs', label: 'CDRs', icon: FaList, parent: null, color: 'bg-indigo-500' },
    { id: 'cdrs_calendario', label: 'Calendario', icon: FaCalendarAlt, parent: 'cdrs', color: 'bg-indigo-400' },
    { id: 'cdrs_monitor', label: 'Monitor', icon: FaTv, parent: 'cdrs', color: 'bg-pink-500' },
    { id: 'clearcom', label: 'Clearcom', icon: FaServer, parent: null, color: 'bg-emerald-500' },
    { id: 'clearcom_config', label: 'Configuración de cuentas', icon: FaSlidersH, parent: 'clearcom', color: 'bg-emerald-400' },
    { id: 'clearcom_bloqueos', label: 'Bloqueos', icon: FaLock, parent: 'clearcom', color: 'bg-rose-500' },
    { id: 'analisis', label: 'Análisis', icon: FaChartLine, parent: null, color: 'bg-violet-500' },
    { id: 'analisis_cps', label: 'CPS y Sesiones', icon: FaChartBar, parent: 'analisis', color: 'bg-violet-400' },
    { id: 'analisis_trafico', label: 'Tráfico por result', icon: FaFileExcel, parent: 'analisis', color: 'bg-emerald-500' },
];

/**
 * Componente Toggle Switch reutilizable
 */
export const ToggleSwitch = ({ checked, onChange, disabled = false }) => (
    <label className="relative inline-flex items-center cursor-pointer">
        <input
            type="checkbox"
            checked={checked}
            onChange={(e) => onChange(e.target.checked)}
            disabled={disabled}
            className="sr-only peer"
        />
        <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-cyan-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-cyan-600"></div>
    </label>
);

/**
 * Componente para gestionar menús del sidebar
 * 
 * @param {Object} props
 * @param {Array} props.menusActivos - Array de IDs de menús activos
 * @param {Function} props.onToggleMenu - Callback cuando se activa/desactiva un menú
 * @param {Function} props.onToggleAllMenus - Callback cuando se marca/desmarca todos los menús de un padre
 * @param {boolean} props.showTitle - Si debe mostrar el título "MENÚS DEL SIDEBAR DISPONIBLES"
 * @param {string} props.className - Clases CSS adicionales
 */
export default function MenusSidebarManager({
    menusActivos = [],
    onToggleMenu,
    onToggleAllMenus,
    showTitle = true,
    className = ""
}) {
    const parentMenus = AVAILABLE_MENUS.filter(m => m.parent === null);
    const getChildMenus = (parentId) => AVAILABLE_MENUS.filter(m => m.parent === parentId);
    const isMenuActive = (menuId) => menusActivos.includes(menuId);

    const getActiveCount = (parentId) => {
        const children = getChildMenus(parentId);
        return children.filter(c => isMenuActive(c.id)).length;
    };

    return (
        <div className={className}>
            {showTitle && (
                <h3 className="text-lg font-bold text-gray-800 mb-4 flex items-center gap-2">
                    <span>📱</span> MENÚS DEL SIDEBAR DISPONIBLES
                </h3>
            )}

            <div className="space-y-4">
                {/* Inicio */}
                <div className="bg-white border-2 border-gray-200 rounded-lg p-4">
                    <div className="flex items-center justify-between">
                        <div className="flex items-center gap-3">
                            <div className={`w-10 h-10 rounded-full ${isMenuActive('inicio') ? 'bg-cyan-500' : 'bg-gray-300'} flex items-center justify-center text-white shadow-md transition-colors`}>
                                <FaHome size={20} />
                            </div>
                            <span className="font-medium text-gray-900">Inicio</span>
                        </div>
                        <ToggleSwitch
                            checked={isMenuActive('inicio')}
                            onChange={() => onToggleMenu('inicio')}
                        />
                    </div>
                </div>

                {/* Menús con hijos (Admon, CDRs) */}
                {parentMenus.filter(m => m.id !== 'inicio').map(menuPadre => {
                    const hijos = getChildMenus(menuPadre.id);
                    const activeCount = getActiveCount(menuPadre.id);
                    const IconoPadre = menuPadre.icon;

                    return (
                        <div key={menuPadre.id} className="bg-white border-2 border-gray-200 rounded-lg p-4">
                            <div className="flex items-center justify-between mb-3">
                                <div className="flex items-center gap-3">
                                    <div className={`w-10 h-10 rounded-full ${menuPadre.color} flex items-center justify-center text-white shadow-md`}>
                                        <IconoPadre size={20} />
                                    </div>
                                    <div>
                                        <div className="font-semibold text-gray-900">{menuPadre.label}</div>
                                        <div className="text-xs text-gray-500">
                                            {activeCount} de {hijos.length} submenús activos
                                        </div>
                                    </div>
                                </div>
                                {onToggleAllMenus && (
                                    <button
                                        onClick={() => onToggleAllMenus(menuPadre.id)}
                                        className="text-sm text-cyan-600 hover:text-cyan-700 font-medium"
                                    >
                                        Marcar todos
                                    </button>
                                )}
                            </div>

                            <div className="space-y-2 ml-14 border-t pt-3">
                                {hijos.map(hijo => {
                                    const IconoHijo = hijo.icon;
                                    return (
                                        <div key={hijo.id} className="flex items-center justify-between py-2">
                                            <div className="flex items-center gap-3">
                                                <div className={`w-8 h-8 rounded-full ${isMenuActive(hijo.id) ? hijo.color : 'bg-gray-300'} flex items-center justify-center text-white shadow transition-colors`}>
                                                    <IconoHijo size={14} />
                                                </div>
                                                <span className="text-sm text-gray-700">{hijo.label}</span>
                                            </div>
                                            <ToggleSwitch
                                                checked={isMenuActive(hijo.id)}
                                                onChange={() => onToggleMenu(hijo.id)}
                                            />
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    );
                })}
            </div>

            {/* Resumen de permisos */}
            <div className="mt-4 p-4 bg-gray-50 rounded-lg">
                <h5 className="text-sm font-semibold text-gray-700 mb-2">Resumen de Permisos</h5>
                <p className="text-xs text-gray-600">
                    <strong>{menusActivos.length}</strong> de{' '}
                    <strong>{AVAILABLE_MENUS.filter(m => m.parent !== null || m.id === 'inicio').length}</strong> menús habilitados
                </p>
            </div>
        </div>
    );
}

/**
 * Hook personalizado para gestionar menús del sidebar
 * 
 * @param {Array} initialMenus - Array inicial de IDs de menús activos
 * @returns {Object} - { menusActivos, toggleMenu, toggleAllMenus, setMenusActivos }
 */
export function useMenusSidebar(initialMenus = []) {
    const [menusActivos, setMenusActivos] = React.useState(initialMenus);

    const toggleMenu = (menuId) => {
        setMenusActivos(prev =>
            prev.includes(menuId)
                ? prev.filter(m => m !== menuId)
                : [...prev, menuId]
        );
    };

    const toggleAllMenus = (parentId) => {
        const children = AVAILABLE_MENUS.filter(m => m.parent === parentId);
        const allActive = children.every(c => menusActivos.includes(c.id));

        let nuevosMenus = [...menusActivos];
        children.forEach(child => {
            if (allActive) {
                nuevosMenus = nuevosMenus.filter(m => m !== child.id);
            } else {
                if (!nuevosMenus.includes(child.id)) {
                    nuevosMenus.push(child.id);
                }
            }
        });

        setMenusActivos(nuevosMenus);
    };

    return {
        menusActivos,
        toggleMenu,
        toggleAllMenus,
        setMenusActivos
    };
}

/**
 * Función helper para obtener el label de un menú por su ID
 */
export function getMenuLabel(menuId) {
    const menu = AVAILABLE_MENUS.find(m => m.id === menuId);
    return menu ? menu.label : menuId;
}

/**
 * Función helper para obtener todos los menús hijo de un padre
 */
export function getChildMenus(parentId) {
    return AVAILABLE_MENUS.filter(m => m.parent === parentId);
}

/**
 * Función helper para obtener todos los menús padre
 */
export function getParentMenus() {
    return AVAILABLE_MENUS.filter(m => m.parent === null);
}